import LeadGuarantee from 'app/shared/model/LeadGuarantee';
import RentGuarantee from 'app/shared/model/RentGuarantee';
import PaidInclusion from 'app/shared/model/PaidInclusion';

const CurrentProperty = ({
    aliasEncoded = '',
    street = '',
    city = '',
    state = '',
    zip = '',
    unit = '',
    active = false, // from details endpoint
    isArchived = false, // from overview endpoint
    autoBill = false,
    numUnits = '',
    archived = false,
    canBeArchived = true,
    canUpdateActiveStatus = false,
    isAddressEditable = true,
    hasVrModels = false,
    isEditable = true,
    isFeed = false,
    leadGuarantee = {},
    paidInclusion = {},
    paidInclusionSelectedProductType = 1,
    propertyType = '',
    listingTypeCode = -1,
    dateLastActivated = '',
    expirationDate = '',
    numLeadsSinceLastActivated = 0,
    isAddressValid = true,
    isConnectedExperience = false,
    listingAlias = '',
    floorplans = [],
    rentGuarantee = {},
} = {}) => ({
    aliasEncoded: String(aliasEncoded),
    street: String(street),
    city: String(city),
    state: String(state),
    zip: String(zip),
    unit: String(unit),
    active: Boolean(active),
    numUnits: String(numUnits),
    archived: Boolean(archived),
    isArchived: Boolean(isArchived),
    autoBill: Boolean(autoBill),
    canBeArchived: Boolean(canBeArchived),
    canUpdateActiveStatus: Boolean(canUpdateActiveStatus),
    isAddressEditable: Boolean(isAddressEditable),
    hasVrModels: Boolean(hasVrModels),
    isEditable: Boolean(isEditable),
    isFeed: Boolean(isFeed),
    leadGuarantee: LeadGuarantee(leadGuarantee),
    paidInclusion: PaidInclusion(paidInclusion),
    paidInclusionSelectedProductType: Number(paidInclusionSelectedProductType),
    propertyType: String(propertyType),
    listingTypeCode: Number(listingTypeCode),
    dateLastActivated: String(dateLastActivated),
    expirationDate: String(expirationDate),
    numLeadsSinceLastActivated: Number(numLeadsSinceLastActivated),
    isAddressValid: Boolean(isAddressValid),
    isConnectedExperience: Boolean(isConnectedExperience),
    listingAlias: String(listingAlias),
    price: Number(floorplans[0]?.price),
    securityDeposit: Number(floorplans[0]?.securityDeposit),
    rentGuarantee: RentGuarantee(rentGuarantee),
});

export default CurrentProperty;
